import _ from 'lodash';

const mutations = {};

/**
 * point 정보
 * @param {*} state
 * @param {Object} value
 */
mutations.SET_POINTINFO = (state, value) => {
  state.point.pointInfo = value;
};

/**
 * point 내역
 * @param {*} state
 * @param {Object} value
 */
mutations.SET_POINTHISTORY = (state, value) => {
  state.point.pointList = value;
};

/**
 * point 내역 현재 페이지
 * @param {*} state
 * @param {Number} value
 */
mutations.SET_POINTLISTPAGENO = (state, value) => {
  state.point.pointListPageNo = value;
};

/**
 * point 내역 시작일
 * @param {*} state
 * @param {String} value
 */
mutations.SET_POINTLISTSTARTDATE = (state, value) => {
  state.point.pointListStartDate = value;
};

/**
 * point 내역 종료일
 * @param {*} state
 * @param {String} value
 */
mutations.SET_POINTLISTENDDATE = (state, value) => {
  state.point.pointListEndDate = value;
};

/**
 * point 내역 상태
 * @param {*} state
 * @param {Number} value
 */
mutations.SET_POINTLISTSTATUS = (state, value) => {
  state.point.pointListStatus = value;
};

export default {
  ...mutations,
};
